/**
 * Loading skeleton for every onboarding route.
 *
 * Renders inside the real OnboardingShell so the top chrome, stepper, rail,
 * and 2-column layout match the live page exactly. When `me` resolves, only
 * the inner pulsing blocks swap to real content — no layout jump, no shell
 * flicker. See STATUS/PLAN_ONBOARDING_REDESIGN_PORT.md.
 */

import { OnboardingShell } from '@/components/onboarding/OnboardingShell';
import type { OnboardingRailState } from '@/components/onboarding/OnboardingRail';

const PLACEHOLDER_STATE: OnboardingRailState = {
  accountCreated: true,
  profileDone: false,
  snippetDone: false,
  adsDone: false,
  whatsappDone: false,
};

const TITLES: Record<1 | 2 | 3 | 4, string> = {
  1: 'Set up your business',
  2: 'Install the snippet',
  3: 'Connect your ad platforms',
  4: 'Go live on WhatsApp',
};

export function OnboardingSkeleton({ current = 1 }: { current?: 1 | 2 | 3 | 4 }) {
  return (
    <OnboardingShell current={current} title={TITLES[current]} state={PLACEHOLDER_STATE}>
      <div aria-busy="true" aria-live="polite" className="space-y-4">
        <div aria-hidden="true" className="h-12 w-full animate-pulse rounded-2xl bg-muted/60" />
        <div aria-hidden="true" className="h-12 w-full animate-pulse rounded-2xl bg-muted/60" />
        <div aria-hidden="true" className="h-32 w-full animate-pulse rounded-3xl bg-muted/40" />
        <div aria-hidden="true" className="h-12 w-40 animate-pulse rounded-full bg-brand/40" />
      </div>
    </OnboardingShell>
  );
}
